import {gql} from '@apollo/client';

export const DOCUMENT_UPLOADER_FORM_CONFIGS = gql`
  query documentUploaderFormConfigs {
    documentUploaderFormConfigs {
      enumName
      category
      subcategory
      dateFieldLabel
      shouldShowProvider
      shouldShowTaxYear
      shouldShowPlanNumber
      shouldShowSecondContact
      providerFieldLabel
    }
  }
`;
